import { useState } from "react";
import { makeStyles } from "@mui/styles";
import FlatIconButton from "../../DesignSystem/FlatButton";
import ModalAlert from "../../DesignSystem/ModalAlert";
import TextFieldCode from "../../DesignSystem/TextFieldCode";

import { ConfirmSignUpCode } from "../Infrastructure/User.presenter"; 

const registerBtn = {
  position: "absolute",
  bottom: "45px",
  left: "calc(50% - 145px)",
  fontSize: "0.875rem",
  border: "2px solid white",
  filter: "drop-shadow(0px 4px 4px rgba(130, 130, 130, 0.25))"
}

const useStyles = makeStyles((theme) => ({
  formStyles: {
    marginTop: 40,
    width: "100%",
    maxWidth: "780px",
    maxHeight: 949,
    minHeight: 800,
    margin: "auto",
    position: "relative",
    padding: "20px 40px 90px",
    background: "white",
    borderRadius: 10,
    height: "auto",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "start",
    flexDirection: "column",
    gap: 25,
    [theme.breakpoints.down("sm")]:{
      padding: "25px 15px 90px",
      minHeight: "500px",
      background: "none"
    },
  },
  title:{
    maxWidth: "489px",
    fontSize: "3rem",
    lineHeight: "58.09px",
    color: "#333333",
    fontWeight: 700,
  },
  description:{
    fontSize: "1.125rem",
    lineHeight: "21.94px",
    color: "#4F4F4F",
    fontWeight: 500
  },
  inputCodeContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    gap: 25,
    [theme.breakpoints.down("md")]:{
      justifyContent: "flex-start",
      gap: 15
    },
  },
  
}));

export default function ValidationCodeModal({codeSubmit,id,data}){
  const classes = useStyles();
  const [code, setCode] = useState({firstNum:"", secondNum: "", thirdNum:"", fourthNum:"", fifthNum:"",sixthNum:""});
  const [sending, setSending] = useState(false);
  const [isOpenAlert, setOpenAlert] = useState(false);
  const [titleAlert, setTitleAlert] = useState("Ha ocurrido un error");
  const [isError, setError] = useState(false);

  const showAlertModal = () => setOpenAlert(true);

  const handleClickOpen = (alertState) => {
    setOpenAlert(alertState);
  };

  const getTextFieldValue = (key, value) => {
    setCode({ ...code, [key]: value});
  };

  const handleSubmit =  async (e) => {
    e.preventDefault();
     setError(false);
    if(code.firstNum !== "" && code.secondNum !== "" && code.thirdNum !== "" && code.fourthNum !== "" && code.fifthNum !== "" && code.sixthNum !== ""){ 
       try {
        setSending(true);
        const registrationCode = `${code.firstNum}${code.secondNum}${code.thirdNum}${code.fourthNum}${code.fifthNum}${code.sixthNum}` 
        await ConfirmSignUpCode({id, code: registrationCode, data}); 
        setSending(false);
        codeSubmit();
      } catch (error) {
        setError(true);
        setSending(false);
        setTitleAlert(`Error: ${error.message}`);
        showAlertModal();
      }
    }else{
      setSending(false);
      setError(true);
      setTitleAlert("Ingresa el código correctamente")
      showAlertModal();
    } 
  }

  return(
    <>
      <form className={classes.formStyles}>
        <h2 className={classes.title}>CÓDIGO DE VALIDACIÓN:</h2>
        <div>
          <p className={classes.description}>Registra el código enviado al número teléfonico proporcionado:</p>
          {/* <p className={classes.description}>correo@example.com</p> */}
        </div>
        <div className={classes.inputCodeContainer}>
          <TextFieldCode id="firstNum" handleTextField={getTextFieldValue}/>
          <TextFieldCode id="secondNum" handleTextField={getTextFieldValue}/>
          <TextFieldCode id="thirdNum" handleTextField={getTextFieldValue}/>
          <TextFieldCode id="fourthNum" handleTextField={getTextFieldValue}/>
          <TextFieldCode id="fifthNum" handleTextField={getTextFieldValue}/>
          <TextFieldCode id="sixthNum" handleTextField={getTextFieldValue}/>
        </div>
        <div className={classes.btnContainer}>
          <FlatIconButton isDisable={sending} widthBtn="290px" typeButton="submit" title={sending ? "Enviando..." : "Registrar"} onClick={handleSubmit} customStyles={registerBtn}/>
        </div>
      </form>
      <ModalAlert title={titleAlert} typeAlert={isError ? "error" : "success"} isOpen={isOpenAlert}  handleAlert={handleClickOpen}/>
    </>
  );
}